import React, {
  createContext,
  useState,
  ReactNode,
  FC,
  useContext,
  useEffect,
} from 'react';
import { IAuthUser, ICallSession, IChatRoom, IDataInvite, IRouletteState, IUser } from '~/types/common';

interface GlobalState {
  context: {
    // isUserBusy: boolean,
    callSession: ICallSession | null,
    isActiveEmoticonContainer: boolean,
    activeSidebarId: string,
    media: string,
    authUser: IAuthUser | null,
    user: IUser | null,
    room: IChatRoom | null,
    rooms: IChatRoom[],
    publicRooms: any[] | null,
    privateWaitingUsers: IDataInvite[] | [],
    searchQuery: string,
    localStream: MediaStream | null;
    remoteStream: MediaStream | null;
    roulette: IRouletteState;
  };
  setContext: (
    context: Partial<GlobalState['context']> | ((prev: GlobalState['context']) => Partial<GlobalState['context']>)
  ) => void;
}

const initState: GlobalState['context'] = {
  // isUserBusy: false,
  callSession: null,
  isActiveEmoticonContainer: false,
  activeSidebarId: "",
  media: "",
  authUser: null,
  user: null,
  room: null,
  rooms: [],
  publicRooms: null,
  privateWaitingUsers: [],
  searchQuery: '',
  localStream: null,
  remoteStream: null,
  roulette: {
    status: 'idle',
    partner: null,
    roomId: null,
    isInitiator: false,
    filters: { roomFilter: 'any', genderFilter: 'any' },
  },
};

// Tworzenie kontekstu
const GlobalContext = createContext<GlobalState | undefined>(undefined);

const GlobalProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [context, setContext] = useState(initState);

  const updateContext = (
    newContext: Partial<GlobalState['context']> | ((prev: GlobalState['context']) => Partial<GlobalState['context']>)
  ) => {
    setContext(prevContext => {
      const contextUpdate =
        typeof newContext === 'function' ? newContext(prevContext) : newContext;

      return {
        ...prevContext,
        ...contextUpdate,
      };
    });
  };

  useEffect(() => {
    if (typeof window !== 'undefined') {
      (window as any).appContext = context;
    }
  }, [context]);

  return (
    <GlobalContext.Provider value={{ context, setContext: updateContext }}>
      {children}
    </GlobalContext.Provider>
  );
};

// Hook do pobierania globalnego kontekstu
const useGlobalContext = (): GlobalState => {
  const context = useContext(GlobalContext);
  if (context === undefined) {
    throw new Error('useGlobalContext must be used within a GlobalProvider');
  }
  return context;
};

export { GlobalProvider, useGlobalContext };
